import { makeStyles } from "tss-react/mui";

const useActionBottomBarStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.surface.navigation,
    maxWidth: "600px",
    right: "auto",
    borderTop: `1px solid ${theme.palette.strokes.defaultGrey}`,
  },
  toolbar: {
    display: "flex",
    justifyContent: "center",
  },
  addButton: {
    margin: "3px 0",
  },
  link: {
    width: "100%",
    textAlign: "end",
  },
}));

export default useActionBottomBarStyles;
